import { examNameToUrlComponent, getImageLink } from "@knowt/syncing/hooks/exams/utils";
import { SUBJECT_TO_CATEGORY, TOPIC_TO_SUBJECT } from "@knowt/syncing/hooks/subjects/constants";
import { subjectNameToUrlComponent } from "@knowt/syncing/hooks/subjects/utils";
import { ExclusiveFlashcardSetItem, ExclusiveNoteItem } from "@knowt/syncing/types/common";

export const BREADCRUMB_ROOTS = {
    home: {
        label: "Home",
        href: "/home",
        img: "/images/home-icon.svg",
    },
    explore: {
        label: "Explore",
        href: "/explore",
        img: "/images/explore-icon.svg",
    },
    blog: {
        label: "Blog",
        href: "/blog",
        img: "/images/blog-icon.svg",
    },
    exams: {
        label: "Exams",
        href: "/exams",
        img: "/images/exams-icon.svg",
    },
};

const BREADCRUMBS_ORDER = ["category", "subject", "topic", "exam_v2", "examUnit"];

const buildTagString = (...param: (string | null)[]) => {
    return param.includes(null) ? "/" : "/" + param.filter(Boolean).join("/");
};

export const getSlugsByContent = ({ note, flashcardSet }: ExclusiveNoteItem | ExclusiveFlashcardSetItem) => {
    const item = note || flashcardSet;
    const type = note ? "notes" : "flashcards";

    const examType = item?.exam_v2?.split(" ")[0] ?? null;
    const subject = item?.subject ?? TOPIC_TO_SUBJECT[item?.topic ?? ""] ?? null;
    const subjectCategory = SUBJECT_TO_CATEGORY[subject ?? ""] ?? null;

    const crumbs = BREADCRUMBS_ORDER.map(key => {
        if (!item?.[key] && key !== "category" && key !== "subject") return null;
        if (item?.exam_v2 && (key === "subject" || key === "topic")) return null;

        switch (key) {
            case "exam_v2": {
                if (!examType || !item.exam_v2) return null;

                return {
                    label: item.exam_v2,
                    href: buildTagString(
                        "exams",
                        examNameToUrlComponent(examType),
                        examNameToUrlComponent(item.exam_v2)
                    ),
                    img: getImageLink(item.exam_v2),
                };
            }
            case "examUnit": {
                if (!examType || !item.exam_v2 || !item.examUnit) return null;

                return {
                    label: item.examUnit,
                    href: buildTagString(
                        "exams",
                        examNameToUrlComponent(examType),
                        "view",
                        examNameToUrlComponent(item.exam_v2),
                        `${examNameToUrlComponent(item.examUnit)}-${type}`
                    ),
                };
            }
            case "category": {
                if (!subjectCategory) return null;

                return {
                    label: subjectCategory,
                    href: buildTagString("subject", `${subjectNameToUrlComponent(subjectCategory)}-${type}`),
                    img: getImageLink(subjectCategory),
                };
            }
            case "subject":
                if (!subject) return null;

                return {
                    label: subject,
                    href: buildTagString(
                        "subject",
                        subjectNameToUrlComponent(subjectCategory),
                        `${subjectNameToUrlComponent(subject)}-${type}`
                    ),
                    img: getImageLink(subject),
                };
            case "topic": {
                if (!item.topic || !subjectCategory || !subject) return null;

                return {
                    label: item.topic,
                    href: buildTagString(
                        "subject",
                        subjectNameToUrlComponent(subjectCategory),
                        subjectNameToUrlComponent(subject),
                        `${subjectNameToUrlComponent(item.topic)}-${type}`
                    ),
                };
            }
            default:
                return null;
        }
    }).filter(Boolean) as {
        label: string;
        href: string;
        img?: string;
    }[];

    return crumbs;
};
